/**
 * 파일명 : com0109m.tsx
 * 설명 : 결재의견보기
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 * 1.0       2020-08-10   윤성수     최초작성
 *     
 */

/************************************************
 * Import 영역  
 ************************************************/
/*  React  */
import React from 'react';

/*  AntD  */
import { Layout, Typography, Table, Button, Row, Col } from 'antd';


const Com0109p = (props:any) => {
    /************************************************
     * 화면 초기화 영역  
     ************************************************/
    /**
     * 기능 : State / Reducer 선언
     * param : 
     */
    const [apprOpnDatas, setApprOpnDatas] = React.useState([]);

    /**
     * 기능 : componentDidMount
     * 설명 : 화면 최초 로드시에 필요한 기능을 구현한다.
     * param : 
     * return : None
     */
    React.useEffect(() => {
        setApprOpnDatas(props.apprOpns);
    }, []);


    /* Render 변수 선언영역 */
    /* AntD */
    const { Content } = Layout;
    const { Text } = Typography;

    /* Table Columns */
    const columns = React.useCallback(() => {
        const arr:any = [
            {
                title: () => <div style={{ textAlign: 'center' }}>결재순번</div>,
                dataIndex: 'apprOrd',
                key: 'apprOrd',
                align: 'center',
                width: 100,
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>결재자부서</div>,
                dataIndex: 'apprUserDeptNm',
                key: 'apprUserDeptNm',
                align: 'center',
                width: 150,
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>결재자직위</div>,
                dataIndex: 'apprUserpostNm',
                key: 'apprUserpostNm',
                align: 'center',
                width: 100,
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>결재자</div>,
                dataIndex: 'apprUserNm',
                key: 'apprUserNm',
                align: 'center',
                width: 100,
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>결재의견</div>,
                dataIndex: 'apprOpn',
                key: 'apprOpn',
                align: 'left',
                width: 300,
            }];
            return arr;
    }, []);

    return (
        <Layout style={{width:850}}>
            <Content>
                <Row>
                    <Table dataSource={apprOpnDatas}
                        key='no'
                        columns={columns()}
                        size='small'
                        style={{width:'100%'}}
                        scroll={{y:300}}
                        pagination={false}
                    />
                </Row>
                <br/>
                <Row justify='center'>
                    <Col>
                        <Button
                            id='btnOk'
                            type='default'
                            className='background-color-default-button' 
                            onClick={() => props.accept()}
                        >
                            닫기
                        </Button>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
};

export default Com0109p;

